module.exports = __webpack_public_path__ + "static/media/serch.ab2e94fe.svg";